module.exports = __webpack_public_path__ + "img/dry.eb011592.svg";